import type { DocumentPage } from '@getaccept/lib-shared/src/types/document-page';

export class DocumentManipulatorHelper {
  static correctPageIndexes(pages: DocumentPage[]): DocumentPage[] {
    if (!pages?.length) {
      return [];
    }
    return pages
      .map((page: DocumentPage, index: number) => ({
        ...page,
        pageNum: index + 1,
      }))
      .sort((pageA: DocumentPage, pageB: DocumentPage) => pageA.pageNum - pageB.pageNum);
  }

  static insertNewPages(pages: DocumentPage[], statePages: DocumentPage[]): DocumentPage[] {
    if (statePages.length === 0) {
      return this.correctPageIndexes(pages);
    }
    const updatedPages: DocumentPage[] = [...statePages];
    updatedPages.splice(pages[0].pageNum - 1, 0, ...pages);
    return this.correctPageIndexes(updatedPages);
  }

  static updatePage(updatedPage: DocumentPage, statePages: DocumentPage[]): DocumentPage[] {
    return statePages.map((statePage: DocumentPage) =>
      statePage.id === updatedPage.id ? updatedPage : statePage
    );
  }

  static filterPage(page: DocumentPage, statePages: DocumentPage[]): DocumentPage[] {
    const filteredPages: DocumentPage[] = statePages.filter(
      (statePage: DocumentPage) => statePage.id !== page.id
    );
    return this.correctPageIndexes(filteredPages);
  }
}
